import { FC, useMemo } from 'react'
import { Heading as ChakraHeading, HeadingProps as ChakraHeadingProps } from '@chakra-ui/react'

export interface HeadingProps {
  level?: 1 | 2 | 3 | 4 | 5 | 6
  noMargin?: boolean
}

/**
 * No idea why, but I can't get theming or textStyles from Chakra to work on Heading component. So as not to waste more
 * time on this, I'm just mapping a series of props based on the level prop. Not as clean, but at this point, I'm giving
 * up.
 *
 * @author Guyllaume Cardinal <guyllaume.cardinal@majisti.com>
 */
const headingStylesMapping: Record<string, ChakraHeadingProps> = {
  h1: {
    fontWeight: ['bold', 'medium', 'medium'],
    paddingBottom: '5',
    paddingTop: '5',
    fontSize: ['xl', '3xl', '4xl'],
    lineHeight: ['7', '10', '15'],
    sx: { wordSpacing: '0.188rem' },
  },
  h3: {
    fontWeight: 'medium',
    paddingBottom: '3',
    paddingTop: '3',
    paddingX: '5',
    fontSize: ['lg', 'xl', 'xl'],
    lineHeight: ['6', '7', '7'],
    sx: { wordSpacing: '0.125rem' },
  },
}

export const Heading: FC<HeadingProps> = ({ children, level = 1, noMargin = true }) => {
  const heading = useMemo<any>(() => `h${level}`, [level])
  const styles = useMemo(
    () => ({
      ...headingStylesMapping[heading],
      padding: noMargin ? '0' : '',
    }),
    [heading, noMargin],
  )

  return (
    <ChakraHeading as={heading} {...styles}>
      {children}
    </ChakraHeading>
  )
}
